interface PlatformDefinition {
  code: number;
  key: string;
  displayName: string;
}

const platformDefinitions: readonly PlatformDefinition[] = [
  { code: 1, key: 'android', displayName: 'Android' },
  { code: 2, key: 'ios', displayName: 'iOS' },
  { code: 3, key: 'webgl', displayName: 'WebGL' },
  { code: 4, key: 'unity_editor', displayName: 'Unity Editor' },
  { code: 255, key: 'other', displayName: 'Other' },
];

export function PlatformBadge(props: { code: number }): React.JSX.Element {
  const platform = resolvePlatform(props.code);
  return <span className={`platform-badge platform-${platform.key}`}>{platform.displayName}</span>;
}

export function PlatformBadgeList(props: { codes: readonly number[] }): React.JSX.Element {
  const badges: React.JSX.Element[] = [];
  for (const code of props.codes) badges.push(<PlatformBadge key={code} code={code} />);
  return <span className="platform-badge-list">{badges}</span>;
}

export function PlatformMultiFilter(props: {
  selectedCodes: readonly number[];
  onChange: (codes: number[]) => void;
}): React.JSX.Element {
  function showAll(): void {
    props.onChange([]);
  }

  function toggle(code: number): void {
    const selected = props.selectedCodes.includes(code);
    const next = selected
      ? props.selectedCodes.filter((entry) => entry !== code)
      : [...props.selectedCodes, code].sort(sortNumbers);
    props.onChange(next);
  }

  return <section className="platform-multi-filter" aria-label="Platforms included">
    <strong>Platforms</strong>
    <div>
      <button className={props.selectedCodes.length === 0 ? 'active' : ''} type="button" aria-pressed={props.selectedCodes.length === 0} onClick={showAll}>All</button>
      {platformDefinitions.map(renderOption)}
    </div>
  </section>;

  function renderOption(platform: PlatformDefinition): React.JSX.Element {
    const selected = props.selectedCodes.includes(platform.code);
    return <button key={platform.code} className={selected ? 'active' : ''} type="button" aria-pressed={selected} onClick={() => toggle(platform.code)}><PlatformBadge code={platform.code} /></button>;
  }
}

export function formatPlatformName(code: number): string {
  return resolvePlatform(code).displayName;
}

export function formatPlatformNames(codes: readonly number[]): string {
  const names: string[] = [];
  for (const code of codes) names.push(formatPlatformName(code));
  return names.join(', ');
}

export function listKnownPlatformCodes(): number[] {
  const codes: number[] = [];
  for (const platform of platformDefinitions) codes.push(platform.code);
  return codes;
}

function resolvePlatform(code: number): PlatformDefinition {
  for (const platform of platformDefinitions) {
    if (platform.code === code) {
      return platform;
    }
  }
  return { code, key: 'unknown', displayName: `Platform ${code}` };
}

function sortNumbers(left: number, right: number): number {
  return left - right;
}
